<ng-select [clearable]="true"
           [searchable]="true"
           appendTo="body"
           [(ngModel)]="selectedCity"
           [items]="(departureCities$ | async)!"
           [loading]="(departureCitiesLoading$ | async)!"
           [groupBy]="'country'"
           [searchFn]="searchDepartureCities"
           [placeholder]="'Common.NotSelected' | translate"
           [notFoundText]="'Common.NotFound' | translate"
           bindValue="id">
  <ng-template ng-optgroup-tmp let-country="item">
    {{ country.country }}
  </ng-template>
  <ng-template ng-label-tmp ng-option-tmp let-item="item">
    <!-- Item can be default ng-select { label, id } object. This check prevent incorrect object usage.-->
    <ng-container *ngIf="item?.nameFrom && item?.id">
      {{ item | departureCityLabel }}
    </ng-container>
  </ng-template>
</ng-select>
